import Route from '@ember/routing/route';

export default class DataManagerExternalInstallRoute extends Route {}
